
export function get_config(){
    return {
	wp_api_host: 'https://test-1.kopie.ramplaankwartier.zonnewarmte.nl',
	wp_api_path: '/wp-json/cft-digidome/v1'
    }
}


